import { useEffect, useMemo, useState } from "react";
import { mapToOptions, PRESENTATION_OPTIONS } from "../utils/utils";

export const useGeneralInformation = ({
  rowEdited,
  countries,
  shippers,
  categories,
  subCategories,
  reduxGetShippers,
  reduxGetCategories,
  reduxGetSubCategories,
}) => {
  const [categorySelected, setCategorySelected] = useState(null);

  const shippersOptions = useMemo(() => {
    return mapToOptions(shippers?.items ?? [], "idCompany", "description");
  }, [shippers]);

  const categoriesOptions = useMemo(() => {
    const categoryIdsWithSubCategories = new Set(
      subCategories.map((sub) => sub.idCategory),
    );
    const filtered = (categories?.items ?? []).filter((cat) =>
      categoryIdsWithSubCategories.has(cat.idCategory),
    );
    return mapToOptions(filtered, "idCategory", "name");
  }, [categories, subCategories]);

  const subCategoriesOptions = useMemo(() => {
    const filteredSubcategories = subCategories.filter(
      (subCategory) => subCategory.idCategory === categorySelected,
    );
    return mapToOptions(filteredSubcategories ?? [], "id", "subCategoryName");
  }, [subCategories, categorySelected]);

  const presentationOptions = useMemo(() => PRESENTATION_OPTIONS, []);

  useEffect(() => {
    reduxGetShippers({
      page: 1,
      offset: "",
      search: "",
    });

    reduxGetCategories({
      page: 1,
      offset: "",
      search: "isActive|true",
    });

    reduxGetSubCategories();
  }, []);

  useEffect(() => {
    const newCategoryId = rowEdited?.category?.idCategory;

    if (newCategoryId && newCategoryId !== categorySelected) {
      setCategorySelected(newCategoryId);
    }
  }, [rowEdited]);

  return {
    shippersOptions,
    categoriesOptions,
    subCategoriesOptions,
    presentationOptions,
    categorySelected,
    setCategorySelected,
  };
};
